import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
// import { string } from 'yup'
import './style.scss'

export const KTTooltipPositions = {
  autoStart: 'auto-start',
  auto: 'auto',
  autoEnd: 'auto-end',
  topStart: 'top-start',
  top: 'top',
  topEnd: 'top-end',
  rightStart: 'right-start',
  right: 'right',
  rightEnd: 'right-end',
  bottomEnd: 'bottom-end',
  bottom: 'bottom',
  bottomStart: 'bottom-start',
  leftEnd: 'left-end',
  left: 'left',
  leftStart: 'left-start',
}

KTTooltip.propTypes = {
  position: PropTypes.oneOf(Object.values(KTTooltipPositions)),
  text: PropTypes.node,
  element: PropTypes.element,
  additionalClassname: PropTypes.string,
  overlayClassname: PropTypes.string,
}

KTTooltip.defaultProps = {
  position: KTTooltipPositions.top,
  text: '',
  element: null,
  additionalClassname: '',
  overlayClassname: '',
}

/**
 *
 * @param {{position: string, text: import('react').ReactNode}} props
 * @returns
 */
function KTTooltip(props) {
  // MARK: --- Params ---
  const { position, text, element, additionalClassname, overlayClassname } =
    props

  return (
    <span className={`KTTooltip ${additionalClassname}`}>
      {(text !== '' && text !== null && text !== undefined) || element ? (
        <OverlayTrigger
          placement={position}
          overlay={
            <Tooltip
              className={`KTTooltipOverlay ${overlayClassname}`}
              style={{ width: 'fit-content' }}
            >
              {element ?? text}
            </Tooltip>
          }
        >
          {props.children}
        </OverlayTrigger>
      ) : (
        <>{props.children}</>
      )}
    </span>
  )
}

export default KTTooltip
